import React, { useEffect, useState } from "react";
import Input from "../../../form/Input";
import Radio from "../../../form/Radio";
import Button from "../../../forms/Button";
import useForm from "../../../../hooks/useForm";
import { addressAddEdit } from "../../../../services/addressService";
import useMutation from "../../../../hooks/useMutation";

const radioOptions = ["Home", "Office", "Billing", "Other"];

const validationRules = {
  name: { required: true },

  address1: { required: true },

  address2: { required: true },

  email: { required: false },

  phone: { required: false },
};

const ManageAddressModalContent = ({
  setAddModalOpen = () => {},
  addressData = null,
  onSuccess = () => {},
}) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({ validationRules });
  // console.log(addressData, "ad");
  useEffect(() => {
    if (addressData?._id) {
      setFieldsValue({
        ...addressData,
        name: addressData.name || "",
        address1: addressData.addressLine1,
        address2: addressData.addressLine2,
        email: addressData.email,
        phone: addressData.phone,
        label: addressData.addressType || "Home",
      });
    }
  }, [addressData]);

  const { mutate, isPending } = useMutation({
    mutationFn: async (formValues) => {
      const payload = {
        id: addressData?._id,
        name: formValues.name,
        address1: formValues.address1,
        address2: formValues.address2,
        // city: "New Delhi", // hardcoded or make field
        // state: "Delhi",
        // country: "IN",
        // zipcode: "110001",
        // type: "Point",
        // coordinates: [77.219657, 28.631451], // Use geolocation or fixed
        phone: formValues.phone || null,
        email: formValues.email || null,
        isDefault: true, // Add toggle if needed
        label: formValues.label,
      };
      return await addressAddEdit({ address: payload, addressId: payload.id });
    },
    onSuccess: (res) => {
      onSuccess(res); // refetch address list or close
      setAddModalOpen(false);
    },
    onError: (err) => {
      console.error("Address save failed:", err);
    },
  });

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e, mutate)} className="space-y-6">
        <div className="space-y-6">
          <div className="relative">
            <div class="font-medium text-md-dark mb-1 text-sm">
              Address Type
            </div>
            <div className="grid grid-cols-4 gap-4">
              {radioOptions.map((label, index) => (
                <Radio
                  // key={index}
                  // id={`address-${label}`}
                  // radioName="addressType"
                  // radioInputClass=""
                  // isChecked={selectedAddressType === label}
                  // radioLabel={label}
                  // value={label}
                  // onChange={(e) => setSelectedAddressType(e.target.value)}
                  key={index}
                  id={`address-${label}`}
                  radioName="label"
                  isChecked={values.label === label}
                  radioLabel={label}
                  value={label}
                  onChange={handleChange}
                />
              ))}
            </div>
          </div>
          <div className="relative">
            <Input
              label={"Full Name"}
              inputPlaceholder={"Enter your full name"}
              // value={fullname}
              // onChange={(e) => setFullname(e.target.value)}
              inputName="name"
              value={values.name}
              onChange={handleChange}
              labelClasses={"!text-sm"}
              inputClasses={"font-medium"}
              {...formValidate(errors, "name")}
            />
          </div>
          <div className="relative">
            <Input
              label={"Address Line 1"}
              inputPlaceholder={"Enter address line 1"}
              // value={addressLine1}
              // onChange={(e) => setAddressLine1(e.target.value)}
              labelClasses={"!text-sm"}
              inputClasses={"font-medium"}
              inputName="address1"
              value={values.address1}
              onChange={handleChange}
              {...formValidate(errors, "address1")}
            />
          </div>
          <div className="relative">
            <Input
              label={"Address Line 2"}
              inputPlaceholder={"Enter address line 2"}
              // value={addressLine2}
              // onChange={(e) => setAddressLine2(e.target.value)}
              labelClasses={"!text-sm"}
              inputClasses={"font-medium"}
              inputName="address2"
              value={values.address2}
              onChange={handleChange}
              {...formValidate(errors, "address2")}
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="relative">
              <Input
                label={"Email Address"}
                inputPlaceholder={"Enter your email address"}
                inputType={"email"}
                // value={email}
                // onChange={(e) => setEmail(e.target.value)}
                labelClasses={"!text-sm"}
                inputClasses={"font-medium"}
                inputName="email"
                value={values.email}
                onChange={handleChange}
                {...formValidate(errors, "email")}
              />
            </div>
            <div className="relative">
              <Input
                label={"Phone Number"}
                inputPlaceholder={"Enter your Phone number"}
                inputType="number"
                // value={phone}
                // onChange={(e) => setPhone(e.target.value)}
                labelClasses={"!text-sm"}
                inputClasses={"font-medium"}
                inputName="phone"
                value={values.phone}
                onChange={handleChange}
                {...formValidate(errors, "phone")}
              />
            </div>
          </div>
        </div>
        <div className="mt-4 pt-4 border-t border-md-pink-light-1 flex items-start justify-between gap-4">
          <div className="ml-auto flex-shrink-0 flex items-center gap-1 md:gap-2">
            <Button
              buttonHasLink={false}
              buttonIcon={"fa-regular fa-fw fa-xmark"}
              buttonIconPosition={"left"}
              buttonLabel={"Cancel"}
              buttonClasses={
                "!h-10 !rounded-md !px-3 !bg-md-pink-light-2 border border-md-pink-light-1 !text-md-pink hover:!bg-md-pink-light-1 hover:border-md-pink/20"
              }
              buttonLabelClasses={"!font-medium !pb-1 !leading-none"}
              buttonFunction={() => setAddModalOpen(false)}
            />
            <Button
              // buttonHasLink={false}
              buttonIcon={"fa-regular fa-fw fa-floppy-disk"}
              // buttonIconPosition={"left"}
              // buttonLabel={"Save"}
              buttonLabel={addressData?._id ? "Update" : "Save"}
              buttonType="submit"
              isLoading={isPending}
              buttonClasses={"!h-10 !rounded-md !px-3"}
              buttonLabelClasses={"!font-medium !pb-1 !leading-none"}
              // buttonFunction={() => setAddModalOpen(false)}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default ManageAddressModalContent;
